var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { Button } from 'components/Button';
import { ButtonDropdown } from 'components/ButtonDropdown';
import { FormInput } from 'components/form/FormInput';
import { Icon } from 'components/Icon';
import { Money } from 'components/Money';
import { DealItemDiscountedPrice } from './DealItemDiscountedPrice';
import { DealConfigurationMobileCard } from './DealItemMobileCard';
import { DateTime } from 'components/DateTime';
import { Text } from 'components/Text';
import { Case } from 'components/util/Case';
import { React } from 'libs/react';
import { calculatePriceCurrency, getMarkup, getMargin, getPricePerUnitFromMarkup, getPricePerUnitFromMargin } from 'helpers/Pricing';
import { useUser } from 'components/user/UserProvider';
import { getMixpanel } from 'helpers/Mixpanel';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { useQuoteContext } from 'modules/public/quote/QuoteScreen';
import { useModal } from 'components/modal/ModalStack';
import { DealItemEditModal } from '../../modal/DealItemEditModal';
import { DealAvailabilityModal } from '../../../modal/DealAvailabilityModal';
import { DealItemPickerPackageDetail } from '../../picker/DealItemPickerPackageDetail';
import { formatFieldValue } from 'helpers/Field';
import i18n from 'components/translation/i18n';
import classNames from 'classnames';
import '../DealItemPanelGroupContent.scss';
import { useDealDetailContext } from 'modules/deal/DealDetails';
import { QuoteMedia } from 'modules/public/quote/components/QuoteMedia';
import { useBreakpoint } from 'components/util/BreakpointProvider';
import { showBundledQuoteConfigurationQuantity } from 'helpers/quoteBundled';
import { getConfigurationEffectiveQuantity, getConfigurationQuantitySuffix } from 'helpers/DealQuantity';
import { useAccount } from 'components/account/AccountProvider';
export function ProposedPackageListItem(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    const { item, data, isDeal, editable, hideSKU, discountRep, pricingDisplay, pricingParametersDisplay, quantityType } = props;
    const user = useUser();
    const modal = useModal();
    const breakpoint = useBreakpoint();
    const _7 = useDealConfiguratorContext(), { includePackage, onPackageDelete, onItemPriceChange, onPackageQuantityChange, deal, updatePackageFieldValues, updateMarkupPerItem, onMoveItemConfiguration, configurationFields, hasDealItemConfigurationTime: hasDealItemConfigurationTimeCfg } = _7, dealConfiguratorContext = __rest(_7, ["includePackage", "onPackageDelete", "onItemPriceChange", "onPackageQuantityChange", "deal", "updatePackageFieldValues", "updateMarkupPerItem", "onMoveItemConfiguration", "configurationFields", "hasDealItemConfigurationTime"]);
    const account = useAccount();
    let dealerColumn = true;
    if (account.tag === 'clubpiscine' || account.tag === 'groupenadeau') {
        dealerColumn = false;
    }
    const { includePackageQuote } = useQuoteContext();
    const quoteContext = useQuoteContext();
    const hasDealItemConfigurationTime = hasDealItemConfigurationTimeCfg ||
        quoteContext.hasDealItemConfigurationTime;
    const dealDetailContext = useDealDetailContext();
    const quantityTypeValue = quantityType && quantityType != ''
        ? quantityType
        : dealConfiguratorContext.quantityType != ''
            ? dealConfiguratorContext.quantityType
            : quoteContext.quantityType;
    const quoteDealItemConfigurationFields = quoteContext.dealItemConfigurationFields.length > 0
        ? quoteContext.dealItemConfigurationFields
        : dealDetailContext.dealItemConfigurationFields.length > 0
            ? dealDetailContext.dealItemConfigurationFields
            : dealConfiguratorContext.dealItemConfigurationFields;
    const pricingParameters = dealConfiguratorContext
        ? dealConfiguratorContext.pricingParameters
        : quoteContext.pricingParameters;
    const dealValue = deal !== null && deal !== void 0 ? deal : quoteContext.deal;
    const showLineDiscount = !editable && !!(dealValue === null || dealValue === void 0 ? void 0 : dealValue.showDiscount) && pricingDisplay !== 'BUNDLED';
    const effectiveQuantity = getConfigurationEffectiveQuantity(data.quantity, (_a = data.package) === null || _a === void 0 ? void 0 : _a.quantityCalculation, dealValue);
    const quantitySuffix = getConfigurationQuantitySuffix((_b = data.package) === null || _b === void 0 ? void 0 : _b.quantityCalculation, dealValue);
    const showConfigurationQuantity = showBundledQuoteConfigurationQuantity(data, pricingDisplay, editable);
    const itemSorting = (_e = JSON.parse((_d = (_c = configurationFields.find((conf) => conf.fieldKey === 'ITEM_SORTING')) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '{}')) === null || _e === void 0 ? void 0 : _e.value;
    const [costPrice, setCostPrice] = useState(calculatePriceCurrency((data === null || data === void 0 ? void 0 : data.package) && (data === null || data === void 0 ? void 0 : data.package.price) ? data === null || data === void 0 ? void 0 : data.package.price : 0, deal === null || deal === void 0 ? void 0 : deal.currency));
    const [amount, setAmount] = useState((_f = data.price) !== null && _f !== void 0 ? _f : 0);
    const dealerDiscount = (discountRep * costPrice) / 100;
    const dealerPrice = costPrice - dealerDiscount;
    const [markup, setMarkup] = useState(getMarkup(dealerPrice, amount).toFixed(0).toString());
    const [margin, setMargin] = useState(getMargin(dealerPrice, amount).toFixed(0).toString());
    const [discount, setDiscount] = useState(Number((((dealerPrice - amount) / dealerPrice) * 100).toFixed(2)));
    const [pricePerUnit, setPricePerUnit] = useState(amount.toFixed(2).toString());
    const [userInputMarkup, setUserInputMarkup] = useState(false);
    const [userInputMargin, setUserInputMargin] = useState(false);
    const [userInputDiscount, setUserInputDiscount] = useState(false);
    const [userInputPricePerUnit, setUserInputPricePerUnit] = useState(true);
    const [quantity, setQuantity] = useState(data.quantity);
    const [openModalEditFields, setOpenModalEditFields] = useState(false);
    const [openModalAvailability, setOpenModalAvailability] = useState(false);
    const markupRef = useRef(null);
    const marginRef = useRef(null);
    const discountRef = useRef(null);
    const pricePerUnitRef = useRef(null);
    useEffect(() => {
        setPricePerUnit(dealerPrice.toFixed(2));
    }, [amount]);
    useEffect(() => {
        var _a;
        setQuantity(data.quantity);
        const newPrice = (_a = data.price) !== null && _a !== void 0 ? _a : 0;
        setPricePerUnit(Number.isFinite(newPrice) ? newPrice.toFixed(2) : '0');
        setMarkup(getMarkup(dealerPrice, newPrice).toFixed(0).toString());
        setMargin(getMargin(dealerPrice, newPrice).toFixed(0).toString());
        setDiscount(dealerPrice !== 0
            ? Number((((dealerPrice - newPrice) / dealerPrice) * 100).toFixed(2))
            : 0);
    }, [data, dealerPrice]);
    useEffect(() => {
        setCostPrice(calculatePriceCurrency((data === null || data === void 0 ? void 0 : data.package) && (data === null || data === void 0 ? void 0 : data.package.price) ? data === null || data === void 0 ? void 0 : data.package.price : 0, deal === null || deal === void 0 ? void 0 : deal.currency));
    }, [deal === null || deal === void 0 ? void 0 : deal.currency]);
    /**
     * @component onPressAddPackageToItem
     * @since 1.0.0
     * @hidden
     */
    const onPressAddPackageToItem = () => {
        includePackage(item, data);
    };
    /**
     * @component onPressDeleteProposedPackage
     * @since 1.0.0
     * @hidden
     */
    const onPressDeleteProposedPackage = () => {
        onPackageDelete(item, data);
    };
    /**
     * @component onPressAddPackage
     * @since 1.0.0
     * @hidden
     */
    const onPressAddPackage = () => {
        var _a, _b;
        getMixpanel((_a = user.user) === null || _a === void 0 ? void 0 : _a.email, 'Add proposed package', {
            item: (_b = data.package) === null || _b === void 0 ? void 0 : _b.title
        });
        includePackageQuote(item, data);
    };
    /**
     * @function onMarkupChange
     * @since 1.0.0
     * @hidden
     */
    const onMarkupChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMarkup(dealerPrice, Number(value));
        setMarkup(value);
        updateMarkupPerItem(data.id, Number(value), false);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onMarginChange
     * @since 1.0.0
     * @hidden
     */
    const onMarginChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMargin(dealerPrice, Number(value));
        setMargin(value);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onDiscountChange
     * @since 1.0.0
     * @hidden
     */
    const onDiscountChange = (value) => {
        const pricePerUnit = dealerPrice - (dealerPrice * Number(value)) / 100;
        setDiscount(Number(value));
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onPricePerUnitChange
     * @since 1.0.0
     * @hidden
     */
    const onPricePerUnitChange = (value) => {
        const markup = getMarkup(dealerPrice, Number(value)).toFixed(0);
        const margin = getMargin(dealerPrice, Number(value)).toFixed(0);
        const discount = Number((((dealerPrice - Number(value)) / dealerPrice) * 100).toFixed(2));
        setPricePerUnit(value);
        setMarkup(markup);
        setMargin(margin);
        setDiscount(discount);
        updateMarkupPerItem(data.id, Number(markup), false);
    };
    /**
     * @function onPriceChange
     * @since 1.0.0
     * @hidden
     */
    const onPriceChange = (value) => {
        var _a;
        if (item.packages && (data === null || data === void 0 ? void 0 : data.id)) {
            const tempPackages = [...item.packages];
            const packageIndex = item.packages.findIndex((pack) => pack.id === (data === null || data === void 0 ? void 0 : data.id));
            if (packageIndex > -1) {
                tempPackages[packageIndex] = Object.assign(Object.assign({}, tempPackages[packageIndex]), { price: value });
                onItemPriceChange &&
                    onItemPriceChange(Object.assign(Object.assign({}, ((_a = deal === null || deal === void 0 ? void 0 : deal.items.find((i) => i.id === item.id)) !== null && _a !== void 0 ? _a : item)), { packages: tempPackages }));
            }
        }
    };
    /**
     * @function onItemPriceOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onPriceOnBlur = () => {
        onPriceChange(Number(pricePerUnit));
    };
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChange = (value) => {
        setQuantity(Number(value));
    };
    /**
     * @function onQuantityChangeOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChangeOnBlur = () => {
        if (quantity !== data.quantity) {
            const onQuantityChangeHandler = deal
                ? onPackageQuantityChange
                : quoteContext.onPackageQuantityChange;
            onQuantityChangeHandler(item, data, quantity);
        }
    };
    /**
     * @function onMarkupClick
     * @since 1.0.0
     * @hidden
     */
    const onMarkupClick = () => {
        var _a;
        setUserInputMarkup(true);
        setUserInputMargin(false);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = markupRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onMarginClick
     * @since 1.0.0
     * @hidden
     */
    const onMarginClick = () => {
        var _a;
        setUserInputMargin(true);
        setUserInputMarkup(true);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = marginRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onDiscountClick
     * @since 1.0.0
     * @hidden
     */
    const onDiscountClick = () => {
        var _a;
        setUserInputMarkup(false);
        setUserInputMargin(false);
        setUserInputDiscount(true);
        setUserInputPricePerUnit(false);
        (_a = discountRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onPricePerUnitClick
     * @since 1.0.0
     * @hidden
     */
    const onPricePerUnitClick = () => {
        var _a;
        setUserInputPricePerUnit(true);
        setUserInputMargin(false);
        setUserInputDiscount(false);
        setUserInputMarkup(false);
        (_a = pricePerUnitRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onEditPress
     * @since 1.0.0
     * @hidden
     */
    function onEditPress() {
        setOpenModalEditFields(true);
    }
    /**
     * @function onManagePackage
     * @since 1.0.0
     * @hidden
     */
    function onManagePackage(value) {
        switch (value) {
            case 'include':
                onPressAddPackageToItem();
                break;
            case 'delete':
                onPressDeleteProposedPackage();
                break;
            case 'moveUp':
                onMoveItemConfiguration(item, data, 'package', 'up');
                break;
            case 'moveDown':
                onMoveItemConfiguration(item, data, 'package', 'down');
                break;
            case 'checkAvailability':
                setOpenModalAvailability(true);
                break;
        }
    }
    /**
     * @function onShowPackageDetails
     * @since 1.0.0
     * @hidden
     * */
    const onShowPackageDetails = () => {
        var _a;
        if (data.package) {
            modal.present({
                title: (_a = data.package.sku) !== null && _a !== void 0 ? _a : t('Package details'),
                picto: '',
                className: 'deal-sale-item-selector-item-modal',
                modal: React.createElement(DealItemPickerPackageDetail, { data: data.package })
            });
        }
    };
    /**
     * @function onCloseModal
     * @since 1.0.0
     * @hidden
     */
    const onCloseModal = () => {
        if (openModalEditFields) {
            setOpenModalEditFields(false);
        }
        if (openModalAvailability) {
            setOpenModalAvailability(false);
        }
    };
    const dropdown = [];
    dropdown.push({
        value: 'include',
        picto: 'plus',
        label: t('Include')
    });
    if (itemSorting === 'ORDER') {
        dropdown.push({
            value: 'moveUp',
            picto: 'arrow-up',
            label: t('Move up')
        });
        dropdown.push({
            value: 'moveDown',
            picto: 'arrow-down',
            label: t('Move down')
        });
    }
    if (user.can('calendar.availability.check')) {
        dropdown.push({
            value: 'checkAvailability',
            picto: 'calendar-check',
            label: t('Check availability')
        });
    }
    dropdown.push({
        value: 'delete',
        picto: 'times',
        label: t('Remove')
    });
    useEffect(() => {
        setPricePerUnit(amount.toFixed(2).toString());
    }, [amount]);
    // Check if item have infos or image
    const hasInfos = !!((_g = data.package) === null || _g === void 0 ? void 0 : _g.infos) || !!((_h = data.package) === null || _h === void 0 ? void 0 : _h.options);
    const isClickable = hasInfos;
    const className = classNames('deal-item-panel-group-content', 'deal-item-panel-group-content-proposed-options-row', { 'deal-item-panel-group-content--isClickable': isClickable && !editable }, props.className);
    return editable || (!editable && breakpoint.isAboveOrEqual('md')) ? (React.createElement(React.Fragment, null,
        React.createElement("tr", { className: className, onClick: isClickable && !editable ? onShowPackageDetails : undefined },
            React.createElement("td", { className: "deal-item-panel-group-content-cell--primary", "data-label": t('Package') },
                React.createElement("div", { className: "deal-item-panel-group-heading-title" },
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-caption" },
                        React.createElement("div", { className: "deal-item-panel-group-heading-title-caption-title" },
                            React.createElement("div", { className: "deal-item-panel-group-content-cell--primary--title" },
                                !((_j = data.package) === null || _j === void 0 ? void 0 : _j.active) || ((_k = data.package) === null || _k === void 0 ? void 0 : _k.deletedAt) ? (React.createElement(Icon, { value: "exclamation-triangle", style: "danger", tooltip: t('This item is no longer available.') })) : isClickable ? (React.createElement(Button, { style: "picto", picto: ((_l = data.package) === null || _l === void 0 ? void 0 : _l.icon) || 'circle-info', onPress: editable ? onShowPackageDetails : undefined })) : (React.createElement(Button, { style: "picto", picto: "", disabled: true })),
                                data.alternativeTo && (React.createElement("div", { className: "deal-item-panel-group-content-title-tooltip" },
                                    React.createElement(Icon, { className: "deal-item-panel-group-content-title-tooltip-picto", value: "right-left" }),
                                    React.createElement(Text, { className: "deal-item-panel-group-content-title-tooltip-value", value: t('Alternative to') +
                                            ' ' +
                                            ((_p = (_o = (_m = item.packages) === null || _m === void 0 ? void 0 : _m.find((pack) => { var _a; return ((_a = pack.package) === null || _a === void 0 ? void 0 : _a.id) === data.alternativeTo; })) === null || _o === void 0 ? void 0 : _o.package) === null || _p === void 0 ? void 0 : _p.title) }))),
                                React.createElement(Text, { className: "deal-item-panel-group-content-value deal-item-panel-group-content-value--title", value: (_q = data.package) === null || _q === void 0 ? void 0 : _q.title, onClick: editable ? onShowPackageDetails : undefined })))))),
            hideSKU === 'FALSE' && (React.createElement("td", null,
                React.createElement(Text, { className: "deal-item-panel-group-content-value deal-item-panel-group-content-value--sku", value: (_r = data.package) === null || _r === void 0 ? void 0 : _r.sku }))),
            React.createElement("td", null, ((_s = data.package) === null || _s === void 0 ? void 0 : _s.groups) && ((_t = data.package) === null || _t === void 0 ? void 0 : _t.groups.length) > 0 && (React.createElement(Text, { className: classNames({ 'deal-item-panel-group-content-value': true }, {
                    'deal-item-panel-group-content-value--group': (_u = data.package) === null || _u === void 0 ? void 0 : _u.groups
                }), value: ((_v = data.package) === null || _v === void 0 ? void 0 : _v.groups) && ((_w = data.package) === null || _w === void 0 ? void 0 : _w.groups.length) > 0
                    ? (_x = data.package) === null || _x === void 0 ? void 0 : _x.groups[0].title
                    : '' }))),
            hasDealItemConfigurationTime && (React.createElement("td", { className: "field-cell", "data-label": t('Time') }, editable ? (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => onEditPress() }, data.startTime || data.endTime ? (React.createElement("span", { className: "deal-item-panel-group-content-value" },
                data.startTime && (React.createElement(DateTime, { date: false, time: true, value: data.startTime, hh: "2-digit", mm: "2-digit" })),
                data.startTime && data.endTime && ' — ',
                data.endTime && (React.createElement(DateTime, { date: false, time: true, value: data.endTime, hh: "2-digit", mm: "2-digit" })))) : (React.createElement(Button, { style: "picto", picto: "clock" })))) : data.startTime || data.endTime ? (React.createElement("span", { className: "deal-item-panel-group-content-value" },
                data.startTime && (React.createElement(DateTime, { date: false, time: true, value: data.startTime, hh: "2-digit", mm: "2-digit" })),
                data.startTime && data.endTime && ' — ',
                data.endTime && (React.createElement(DateTime, { date: false, time: true, value: data.endTime, hh: "2-digit", mm: "2-digit" })))) : null)),
            quoteDealItemConfigurationFields.length > 0 &&
                (quoteDealItemConfigurationFields === null || quoteDealItemConfigurationFields === void 0 ? void 0 : quoteDealItemConfigurationFields.map((field) => {
                    var _a, _b;
                    const v = (_b = (_a = data.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => { var _a; return ((_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id) === field.id; })) === null || _b === void 0 ? void 0 : _b.value;
                    return (React.createElement("td", { key: field.id, className: "field-cell" }, editable ? (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => onEditPress() }, v ? (field.type === 'FILE' ? (React.createElement(Icon, { value: "file" })) : (React.createElement(React.Fragment, null,
                        React.createElement(Text, { className: "deal-item-panel-group-content-value", value: formatFieldValue(v, field.type, field, i18n.language) }),
                        React.createElement(Icon, { value: "pencil" })))) : (React.createElement(Button, { picto: field.type === 'DATE'
                            ? 'calendar'
                            : field.type === 'TIME'
                                ? 'clock'
                                : 'plus', style: "picto" })))) : field.type === 'FILE' ? (React.createElement(QuoteMedia, { style: "normal", value: formatFieldValue(v, field.type, field), noLabel: true })) : (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: v
                            ? formatFieldValue(v, field.type, field, i18n.language)
                            : '' }))));
                })),
            (quantityTypeValue === 'GRANULAR' ||
                quantityTypeValue === 'ITEM_CONFIGURATION') && (React.createElement("td", { "data-label": t('Quantity'), className: "deal-item-panel-group-content-value--qty" }, editable ? (React.createElement(FormInput, { className: "deal-item-panel-group-content-input input-quantity", type: "number", name: "quantity", value: quantity.toString(), onChange: (value) => onQuantityChange(value), onBlur: onQuantityChangeOnBlur, min: "0", size: "small", suffix: quantitySuffix })) : showConfigurationQuantity ? (React.createElement("div", { className: "deal-item-panel-group-content-value--uneditable-qty" },
                React.createElement(Text, { className: "deal-item-panel-group-content-value", value: quantity.toString() }),
                React.createElement(Case, { is: !!quantitySuffix },
                    React.createElement(Text, { className: "deal-item-panel-group-content-value--unitOfMeasurement", value: quantitySuffix })))) : null)),
            React.createElement(Case, { is: editable },
                React.createElement("td", { "data-label": t('Price'), className: "deal-item-panel-group-content-price" },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: costPrice }))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer discount'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerDiscount })))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer price'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerPrice })))),
            editable && pricingParameters === 'DISCOUNT' && (React.createElement("td", { "data-label": t('Discount') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon  input-markup-icon-content", onClick: onDiscountClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputDiscount ? onDiscountChange : undefined, value: discount.toString(), disabled: userInputDiscount ? false : true, className: userInputDiscount ? 'number-input isActive' : 'number-input', ref: discountRef, size: "small" }),
                React.createElement(Icon, { value: userInputDiscount ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARKUP' &&
                pricingParametersDisplay == 'line' && (React.createElement("td", { "data-label": t('Markup') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon-content", onClick: onMarkupClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMarkup ? onMarkupChange : undefined, value: markup, disabled: userInputMarkup ? false : true, className: userInputMarkup ? 'number-input isActive' : 'number-input', ref: markupRef, size: "small" }),
                React.createElement(Icon, { value: userInputMarkup ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARGIN' &&
                pricingParametersDisplay == 'line' && (React.createElement("td", { "data-label": t('Margin') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon-content", onClick: onMarginClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMargin ? onMarginChange : undefined, value: margin, disabled: userInputMargin ? false : true, className: userInputMargin ? 'number-input isActive' : 'number-input', ref: marginRef, size: "small" }),
                React.createElement(Icon, { value: userInputMargin ? 'angle-left' : 'angle-right' }))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Selling Price') + ' ($)', className: "deal-item-panel-group-content-input input-profit deal-item-panel-group-content-price", onClick: onPricePerUnitClick }, editable ? (React.createElement(FormInput, { type: "number", suffix: "$", onChange: userInputPricePerUnit ? onPricePerUnitChange : undefined, onBlur: onPriceOnBlur, value: pricePerUnit, disabled: userInputPricePerUnit ? false : true, className: userInputPricePerUnit
                    ? 'number-input isActive'
                    : 'number-input', ref: pricePerUnitRef, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        onPriceOnBlur();
                    }
                }, size: "small" })) : (React.createElement(DealItemDiscountedPrice, { className: "deal-item-panel-group-content-value", value: Number(pricePerUnit), listPrice: costPrice, showDiscount: showLineDiscount })))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Total'), className: "deal-item-panel-group-content-price" },
                React.createElement(Money, { className: "deal-item-panel-group-content-value", value: Number(pricePerUnit) * effectiveQuantity }))),
            isDeal && (React.createElement("td", { "data-label": t('Actions') },
                React.createElement(Case, { is: editable },
                    React.createElement(ButtonDropdown, { options: dropdown, onSelect: onManagePackage, className: "proposed-dropdown" })))),
            !isDeal && (React.createElement("td", { "data-label": t('Actions') },
                React.createElement("div", { onClick: (e) => e.stopPropagation() },
                    React.createElement(Button, { style: "picto", picto: data.alternativeTo ? 'right-left' : 'plus', className: 'deal-item-panel-group-content-add-proposed-button' +
                            (data.alternativeTo
                                ? ' deal-item-panel-group-content-add-proposed-button--alternative'
                                : ''), onPress: onPressAddPackage }))))),
        openModalAvailability && dealValue && (React.createElement(DealAvailabilityModal, { deal: dealValue, onClose: () => setOpenModalAvailability(false), saleItemTitle: (_y = data.package) === null || _y === void 0 ? void 0 : _y.title })),
        openModalEditFields && (React.createElement(DealItemEditModal, { type: "package", item: data, customFields: quoteDealItemConfigurationFields, hasTime: hasDealItemConfigurationTime, onClose: onCloseModal, onUpdateItem: (updatedItem, applyToAll) => {
                var _a, _b, _c;
                const cfg = updatedItem;
                updatePackageFieldValues(item.id, updatedItem.id, (_a = updatedItem.fieldValues) !== null && _a !== void 0 ? _a : [], applyToAll, hasDealItemConfigurationTime
                    ? ((_b = cfg.startTime) !== null && _b !== void 0 ? _b : null)
                    : undefined, hasDealItemConfigurationTime ? ((_c = cfg.endTime) !== null && _c !== void 0 ? _c : null) : undefined);
                setOpenModalEditFields(false);
            } })))) : (React.createElement(DealConfigurationMobileCard, { title: (_z = data.package) === null || _z === void 0 ? void 0 : _z.title, meta: [
            hideSKU === 'FALSE' ? (_0 = data.package) === null || _0 === void 0 ? void 0 : _0.sku : null,
            (_3 = (_2 = (_1 = data.package) === null || _1 === void 0 ? void 0 : _1.groups) === null || _2 === void 0 ? void 0 : _2[0]) === null || _3 === void 0 ? void 0 : _3.title
        ], picto: isClickable ? ((_4 = data.package) === null || _4 === void 0 ? void 0 : _4.icon) || 'circle-info' : null, unavailable: !((_5 = data.package) === null || _5 === void 0 ? void 0 : _5.active) || !!((_6 = data.package) === null || _6 === void 0 ? void 0 : _6.deletedAt), onPress: isClickable ? onShowPackageDetails : undefined, priceDisplay: data.priceDisplay, pricingDisplay: pricingDisplay, pricePerUnit: Number(pricePerUnit), listPrice: costPrice, showDiscount: showLineDiscount, quantity: quantity, effectiveQuantity: effectiveQuantity, quantitySuffix: quantitySuffix, showQuantity: (quantityTypeValue === 'GRANULAR' ||
            quantityTypeValue === 'ITEM_CONFIGURATION') &&
            showConfigurationQuantity, startTime: hasDealItemConfigurationTime ? data.startTime : null, endTime: hasDealItemConfigurationTime ? data.endTime : null, fields: quoteDealItemConfigurationFields, fieldValues: data.fieldValues, actions: React.createElement(Button, { style: "primary", picto: data.alternativeTo ? 'right-left' : 'plus', label: data.alternativeTo ? t('Replace') : t('Add'), onPress: onPressAddPackage }) }));
}
